<template>
	<div class="job-threads">

		<div v-for="job in jobsWithThreads" v-if="job.MessageThread.length > 0">
			<h4>{{ job.job_num }}: {{ job.job_name }}</h4>

			<message-thread-card 
				:key="'job-'+thread.id" v-for="thread in job.MessageThread" 
				:thread="thread"
				:image-url="thread.imageUrl"
				v-on:click="selectThread(thread)">
			</message-thread-card>

			<div class="text-center" v-if="!showingSearchResults">
				<button class="btn btn-sm btn-light" v-on:click.prevent="loadMoreJobThreads(job)">
					<i class="fa fa-chevron-down"></i>
					More...
				</button>
			</div>

		</div>

		<button v-if="!showingSearchResults" class="btn btn-light mb-2" v-on:click="loadMoreJobs">
			<i class="fa fa-chevron-down"></i>
			More Projects/Services with Messages...
		</button>
	</div>
</div>
</template>

<script>
import MessageThreadCard from "./MessageThreadCard"

export default {

	name: 'JobThreadList',
	components: {
		MessageThreadCard
	},
	props: ["jobsWithThreads","showingSearchResults"],
	methods: {
		selectThread(thread) {
			this.$emit("threadClick",thread)
		},
		loadMoreJobs() {
			this.$emit("loadMoreJobs")
		},
		loadMoreJobThreads(job) {
			this.$emit("loadMoreJobThreads",job)
		}
	}

}
</script>
